import {EditorDeleteSelect} from "../editor/editor-delete-select";

export class GeoreferencerDeleteSelect extends EditorDeleteSelect{

}
